import React from "react";
import { useTranslation } from 'react-i18next';
import '../i18n';

// Assets
// import GbFlag from '../assets/flags/gb.webp';
// import FrFlag from '../assets/flags/fr.webp';
// import EsFlag from '../assets/flags/es.webp';

// const languages = [
//   { code: 'en', label: 'language.english', flag: GbFlag },
//   { code: 'fr', label: 'language.french', flag: FrFlag },
//   { code: 'es', label: 'language.spanish', flag: EsFlag },
// ];

interface LanguageSwitcherProps {
  language?: string;
  setLanguage?: (lang: string) => void;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ language: propLanguage}) => {
  const { i18n } = useTranslation();
  // Initialize language from sessionStorage or default to 'en'
  // If controlled, use props; else, use internal state
  const [internalLanguage, setInternalLanguage] = React.useState(() => sessionStorage.getItem('selectedLanguage') || 'en');



  // On mount, set i18n and sessionStorage if not already set
  React.useEffect(() => {
    if (propLanguage !== undefined) {
      // If controlled, don't override parent
      i18n.changeLanguage(propLanguage);
      sessionStorage.setItem('selectedLanguage', propLanguage);
      return;
    }
    const stored = sessionStorage.getItem('selectedLanguage');
    if (!stored) {
      // Try to detect browser/system language
      let browserLang = navigator.language || (navigator.languages && navigator.languages[0]);
      console.log('[LanguageSwitcher] Detected browser/system language:', browserLang);
      if (browserLang) browserLang = browserLang.slice(0,2).toLowerCase();
      let fallbackLang = 'en';
      if (browserLang === 'es' || browserLang === 'fr' || browserLang === 'en') {
        fallbackLang = browserLang;
      }
      sessionStorage.setItem('selectedLanguage', fallbackLang);
      i18n.changeLanguage(fallbackLang);
      setInternalLanguage(fallbackLang);
      console.log(`[LanguageSwitcher] No language in session, system/browser detected: ${browserLang}, using: ${fallbackLang}`);
    } else {
      i18n.changeLanguage(stored);
      setInternalLanguage(stored);
      console.log(`[LanguageSwitcher] Loaded language from session: ${stored}`);
    }
  }, [i18n, propLanguage]);

  React.useEffect(() => {
    if (propLanguage !== undefined) return; // Don't sync if controlled
    if (internalLanguage) {
      i18n.changeLanguage(internalLanguage);
      sessionStorage.setItem('selectedLanguage', internalLanguage);
      console.log(`[LanguageSwitcher] Language state updated: ${internalLanguage}`);
    }
  }, [internalLanguage, i18n, propLanguage]);

  // Do not render any UI, language is auto-selected
  return null;

};